module.exports = __webpack_public_path__ + "img/shopping_cart_black_18dp.6d8a8ec6.svg";